module.exports = __webpack_public_path__ + "img/members.d1e51506.jpg";